module.exports = __webpack_public_path__ + "static/media/fifth-block-img1.daa7fbaa.svg";